import { connect } from 'react-redux';
import { State } from 'store/types';
import View from 'components/MetaInfo';
import { CURRENCY } from 'shared/constants';
import { PageTypes } from '@nykaa/seo/constants';
import { getAbsoluteUrl } from '@nykaa/utils/network/urls';

const mapStateToProps = (state: State) => {
  const { productPage, remoteConfig } = state;
  const title = remoteConfig.configs?.meta?.productPage.title;
  const description = remoteConfig.configs?.meta?.productPage.description;
  const productName = productPage.product?.name || '';
  const regx = /Product_Name/g;
  const productPriceInfo = {
    amount: productPage.product?.offerPrice,
    currency: CURRENCY,
  };

  return {
    metaTitle: title?.replace(regx, productName),
    metaImage: productPage.product?.imageUrl,
    metaDescription: description?.replace(regx, productName),
    metaKeywords: productPage.product?.metaKeywords,
    page: PageTypes.PRODUCT,
    ogType: PageTypes.PRODUCT,
    product: productPriceInfo,
    canonical: getAbsoluteUrl(productPage.product?.slug as string),
  };
};

export default connect(mapStateToProps)(View);
